import React, { useState, useCallback, useEffect } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleChevronLeft, faCircleChevronRight, faCircleXmark } from "@fortawesome/free-solid-svg-icons"
import { Link } from "react-router-dom"
import { useTranslation } from 'react-i18next'; // <--- 1. Import do i18n
import "./wireTestsCapabilities.css"

// --- IMPORTS DOS LOGOS ---
import logoPT from "../../imagens/logos/logoWireTests.png"
// ⚠️ VERIFIQUE SE O NOME DO ARQUIVO ABAIXO EXISTE NA SUA PASTA
import logoEN from "../../imagens/logos/logoWireTestsEn.png" 


function WireTestCapabilities({ listWireTest }) {
    
    // <--- 2. Hook de tradução
    const { t, i18n } = useTranslation();

    // <--- 3. Lógica do logo dinâmico
    const logoByLanguage = i18n.language === 'en' ? logoEN : logoPT;

    const [slideNumber, setSlideNumber] = useState(0)
    const [openModal, setOpenModal] = useState(false)


    const handleOpenModal = (index) => {
        setSlideNumber(index)
        setOpenModal(true)
    }

    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const prevSlide = useCallback(() => {
        slideNumber === 0 ?
            setSlideNumber(listWireTest.length - 1) :
            setSlideNumber(slideNumber - 1)
    }, [slideNumber, listWireTest.length])

    const nextSlide = useCallback(() => {
        slideNumber + 1 === listWireTest.length ?
            setSlideNumber(0) :
            setSlideNumber(slideNumber + 1)

    }, [slideNumber, listWireTest.length])

    useEffect(() => {
        const handleKeyDown = (event) => {
            switch (event.key) {
                case 'Escape':
                    handleCloseModal()
                    break
                case 'ArrowLeft':
                    prevSlide()
                    break;
                case 'ArrowRight':
                    nextSlide()
                    break;
                default:
                    break;
            }
        };

        if (openModal) {
            window.addEventListener('keydown', handleKeyDown);
        }

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [openModal, nextSlide, prevSlide]);

    return (
        <div>
            {openModal &&
                <div className="wireTestSliderWrap">
                    <FontAwesomeIcon icon={faCircleChevronLeft} onClick={prevSlide} className="wireTestBtnPrev" />
                    <FontAwesomeIcon icon={faCircleChevronRight} onClick={nextSlide} className="wireTestBtnNext" />
                    <FontAwesomeIcon icon={faCircleXmark} onClick={handleCloseModal} className="wireTestBtnClose" />
                    <img className="wireTestFullScreenImage" src={listWireTest[slideNumber].img} alt="" />
                </div>
            }
            
            {/* LOGO DINÂMICO */}
            <div className="img-custom-size img-fluid ms-2">
                {/* <--- 4. Uso da variável do logo */}
                <img src={logoByLanguage} alt="logoWireTest"></img>
            </div>

            <div className="wireTestGalleryWrap mx-2">
                {
                    listWireTest && listWireTest.map((image, index) => {
                        return (
                            <div
                                className="wireTestSingle"
                                key={index}
                                onClick={() => handleOpenModal(index)}
                            >

                                <img src={image.img} alt="" />
                            </div>
                        )

                    })

                }
            </div >
            
            {/* BOTÃO VOLTAR TRADUZIDO */}
            <div className="text-center text-nowrap my-4">
                <Link to="/Capabilities/Production">
                    {/* <--- 5. Tradução do botão */}
                    <button className="buttonCapabilities">
                        {t('productionCapabilities.backButton')}
                    </button>
                </Link>
            </div>
        </div>
    )
}

export default WireTestCapabilities